import type { TextareaHTMLAttributes } from 'react'
import { cn } from '@/shared/lib/cn'
import s from './Textarea.module.css'

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>

export function Textarea({ className, ...rest }: TextareaProps) {
  return <textarea className={cn(s.root, className)} {...rest} />
}
